import { render, staticRenderFns } from "./DiagramInformation.vue?vue&type=template&id=c20235a6&scoped=true"
import script from "./DiagramInformation.vue?vue&type=script&lang=ts"
export * from "./DiagramInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20235a6",
  null
  
)

export default component.exports